import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingService from '@/components/Billing/billing-service';
import { VIRTUALLY_UNLIMITED_IDENTIFIER } from '@/components/Billing/billing-service.const';
import { ProductType, FeatureTypes, SelectOption } from '@/components/Billing/billing-types';
// @ts-ignore
import UpgradePlanDialogSelectPlan from '@/components/dialogs/UpgradePlanDialog/UpgradePlanDialogSelectPlan.vue';
// @ts-ignore
import UpgradePlanPayment from '@/components/dialogs/UpgradePlanDialog/UpgradePlanPayment.vue';
import { addBigNumberSuffix } from '@/utils/helpers';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradePlanDialogContent',
  props: {
    planId: null,
    productId: null,
    featureId: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({ (e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
	planId: string;
	productId: ProductType;
	featureId: FeatureTypes;
}


const virtualUnlimitedPlanSuffix = `-${VIRTUALLY_UNLIMITED_IDENTIFIER}`;


const { isAnnuallyPlan, billingPeriod, usePlanById, customerFeatureSubscription, useSubscriptions, useEntitlementById } = useBilling();
useSubscriptions();
const disableToggle = computed(() => props.planId.includes(virtualUnlimitedPlanSuffix));
const entitlementById = useEntitlementById();

const totalDueToday = ref(0);
const selectedPlanId = ref(props.planId);
const plan = computed(() => usePlanById().value(props.planId));
const isEnterprisePlan = computed(() => BillingService.isEnterprisePlan(plan.value));

const isCustomerFeaturesPlan = computed(() => BillingService.isCustomerFeaturesPlan(plan.value));
const currentCustomerFeaturesUsage = computed(() => {
	const subscription = customerFeatureSubscription.value;
	const entitlement = entitlementById.value(FeatureTypes.CustomerTasks);
	if (!entitlement || !subscription) {
		return 0;
	}
	return BillingService.getCustomerFeatureUsageLimit(subscription, false, entitlement);
});

const isPaidPlan = computed(() => BillingService.isPaidPlan(plan.value));
const tasksPriceMap = computed(() =>
	isCustomerFeaturesPlan.value && isPaidPlan.value ? BillingService.getTasksPriceMap(plan.value, billingPeriod.value) : {}
);
const selectOptions = computed<SelectOption[]>(() =>
	Object.keys(tasksPriceMap.value).map<SelectOption>((key) => ({
		value: parseInt(key),
		text: `${addBigNumberSuffix(key)} monthly tasks`,
		suffixText: `$${tasksPriceMap.value[parseInt(key)]} per ${isAnnuallyPlan.value ? 'year' : 'month'}`,
	}))
);
const extractQuantity = (selectOptions: SelectOption[], currentCustomerFeaturesUsage: number) => {
	if (selectOptions.length === 0) {
		return 0;
	}
	const currentOptionValueIndex = selectOptions.findIndex((option) => option.value === currentCustomerFeaturesUsage);
	const optionIndex = currentOptionValueIndex === -1 ? 0 : currentOptionValueIndex;
	return isCustomerFeaturesPlan.value ? selectOptions[optionIndex].value : 0;
};
const quantity = ref<number>(extractQuantity(selectOptions.value, currentCustomerFeaturesUsage.value));
watch(customerFeatureSubscription, () => {
	quantity.value = extractQuantity(selectOptions.value, currentCustomerFeaturesUsage.value);
});

return { __sfc: true,emit, virtualUnlimitedPlanSuffix, props, isAnnuallyPlan, billingPeriod, usePlanById, customerFeatureSubscription, useSubscriptions, useEntitlementById, disableToggle, entitlementById, totalDueToday, selectedPlanId, plan, isEnterprisePlan, isCustomerFeaturesPlan, currentCustomerFeaturesUsage, isPaidPlan, tasksPriceMap, selectOptions, extractQuantity, quantity, UpgradePlanDialogSelectPlan, UpgradePlanPayment }
}

})